<div class="dialog-header" mat-dialog-title>
    <span>{{ data.title }}</span>
    <button class="close-button" (click)="onCancel()" mat-icon-button>
        <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    <p class="message">{{ data.message }}</p>

    <mat-form-field class="search-field" appearance="outline">
        <mat-label>Zoeken in uitvoerders</mat-label>
        <input [formControl]="searchControl" matInput placeholder="Typ om te zoeken..." />
        <mat-icon matPrefix fontSet="fa" fontIcon="fa-search"></mat-icon>
    </mat-form-field>

    <div class="results">
        @for (executor of filteredExecutors; track executor.id) {
            <mat-card
                class="result-card"
                [class.selected]="isExecutorSelected(executor)"
                (click)="onExecutorSelect(executor)">
                <mat-card-content class="result-content">
                    <div class="executor-info">
                        <strong>{{ executor.name }}</strong>
                        @if (executor.firstname && executor.lastname) {
                            <span class="full-name">({{ executor.firstname }} {{ executor.lastname }})</span>
                        }
                    </div>
                    @if (data.sourceExecutor?.id === executor.id) {
                        <span class="current-chip">
                            <mat-icon fontSet="fa" fontIcon="fa-check"></mat-icon>
                            Huidige uitvoerder
                        </span>
                    }
                </mat-card-content>
            </mat-card>
        }

        @if (filteredExecutors.length === 0) {
            <div class="no-results">
                <mat-icon class="no-results-icon" fontSet="fa" fontIcon="fa-search"></mat-icon>
                <p>Geen uitvoerders gevonden</p>
            </div>
        }
    </div>
</mat-dialog-content>

<div class="d-flex justify-content-end action-buttons" mat-dialog-actions>
    <button class="cancel-button" (click)="onCancel()" mat-button>Annuleren</button>
    <button
        class="confirm-button"
        [disabled]="!selectedExecutor"
        (click)="onConfirm()"
        mat-raised-button
        color="primary">
        {{ data.confirmButtonText || 'Verplaatsen' }}
    </button>
</div>
